export const environment = {
  production: false,
  appVersion: '3.0.1',
  // apiUrl: 'http://localhost:5000'
  apiUrl: 'https://nextgenrodeo-develop-services-client.azurewebsites.net',
  notificationService: "https://nextgenrodeo-develop-services-notifications.azurewebsites.net",
  stripe: {
    publishableKey:
      'pk_live_51LFggvAUmgIpCbTFR44RUi30H1eo9KtEWJtgg7sevwhlSgoXkIuXMNzIYLQc9rp9b76ga71Bjax1ameHMMrFFfiR00d0DBpOSb',
    testPublishableKey:
      'pk_test_51LFggvAUmgIpCbTFss0riuCoyo3njhQ5OO7Tv5uPUhRdeNearPZwnTW5nMUJPRHDBhXA7mw2bsxM865KAlN01it200UqJZ5ezp',
    applePayMerchantId: 'merchant.com.nextgenrodeo.app',
    forceTestPayment: true,
  },
};
